module.exports = __webpack_public_path__ + "static/img/12.4dac2d3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/eng/12.png
// module id = iTIu
// module chunks = 0